var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.img-boxed{\r\n    width:100%;\r\n    padding-bottom: 1.5rem;\r\n}\r\n.galeria{\r\n    background-image: url(" + escape(require("../../assets/images/img-background.jpg")) + ");\r\n}\r\n.bg-fotos {\r\n    background-color: #313131;\r\n}\r\n.bg-realiza {\r\n    background-color: #007acc;\r\n}\r\n.fonte18 {\r\n    font-size: 18px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/hyago/Desktop/SiteEventos/src/app/evento-detalhe/evento-detalhe.component.css
// module id = ../../../../../src/app/evento-detalhe/evento-detalhe.component.css
// module chunks = main